module.exports = __webpack_public_path__ + "static/media/facebookIconTrd.2f146518.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/facebookIconTrd.svg
// module id = 136
// module chunks = 0